import React from 'react'
import MediaQuery from 'react-responsive'
import mediaSize from '../../../../constants/mediaSize'

import { Button } from '../../../../Components'

import styles from './styles.module.scss'

import heart from './img/heart.png'

export default () => {
  const invite = localStorage.getItem('invite')
  return (
    (
      <header className={styles.wrap}>
        <div className="base-layout">
          <div className={styles.content}>
            <div className={styles.contentLeft}>
              <h1 className={styles.title}>
                { 'Платежи выплаты + ' }
                <img alt="heart" src={heart} className={styles.titleHartImg} />
              </h1>
              <p className={styles.text}>
                {'Отлично подходит для сервисов фриланса и\u00A0маркетплейсов. '
                  + 'Удобно принимать платежи, быстро делать выплаты.'}
              </p>
              <Button
                type="yellow"
                size="large"
                wrapStyle={styles.button}
                to={`https://lk.tome.ge/signup${invite ? `?invite=${invite}` : ''}`}
                onClick={() => localStorage.removeItem('invite')}
                isExternalLink
                isNotBlank
              >
                { 'Подключиться'.toUpperCase() }
              </Button>
            </div>
            <MediaQuery minWidth={mediaSize.maxPhoneSize}>
              <div className={styles.contentRight}>
                <i className={styles.man} />
                <img
                  alt="blobSmall"
                  src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/home/header/blob_small.png`}
                  className={styles.blobSmall}
                  width={154}
                  height={147}
                />
              </div>
            </MediaQuery>
          </div>
        </div>
      </header>
    )
  )
}
